module.exports = __webpack_public_path__ + "static/media/home.beea9fe6.png";